module.exports = __webpack_public_path__ + "static/galadaeros-867798cf183bfb021807fe853fe024ae.jpg";